import React from 'react';
import { TextInput, ImageInput, ImageField, useTranslate } from 'react-admin';
import { EditableImage } from '../EditableImageField';

/** 1. tasarim — dikey kart / detay gorseli (344 × 194) */
const DESIGN1_WIDTH = 344;
const DESIGN1_HEIGHT = 194;
const DESIGN1_ASPECT = DESIGN1_WIDTH / DESIGN1_HEIGHT;

/** 2. tasarim — yatay liste / poster (4:5 → 1080 × 1350) */
const DESIGN2_WIDTH = 216;
const DESIGN2_HEIGHT = 270;
const DESIGN2_ASPECT = 4 / 5;

/**
 * Event Visuals Tab — iki kirpilmis gorsel:
 * 1. tasarim (bannerCard) + 2. tasarim (banner)
 */
export const EventVisualsTab = ({ record, isEdit = false, ...props }) => {
  const translate = useTranslate();

  return (
    <React.Fragment>
      <h3>{translate('form.visual_design1', 'Yatay Görsel (344×194)')}</h3>
      <span
        style={{
          backgroundColor: '#0ABAB5',
          color: 'white',
          borderRadius: 10,
          fontSize: 12.5,
          padding: 5,
          marginTop: -10,
          marginBottom: 8,
          display: 'inline-block',
        }}
      >
        {translate(
          'form.visual_design1_hint',
          `Yatay görsel ${DESIGN1_WIDTH}×${DESIGN1_HEIGHT}. Ana sayfa 1. tasarım kartı ve etkinlik detayı.`,
        )}
      </span>
      <EditableImage
        record={record}
        source="bannerCard"
        aspect={DESIGN1_ASPECT}
        width={DESIGN1_WIDTH}
        height={DESIGN1_HEIGHT}
        hint={translate(
          'form.design1_crop_hint',
          `1. tasarım ${DESIGN1_WIDTH}×${DESIGN1_HEIGHT}. Kaydetmeden önce kırpın.`,
        )}
        cropTitle={translate('form.design1_crop_title', {
          _: `Görseli Kırp (${DESIGN1_WIDTH}×${DESIGN1_HEIGHT})`,
        })}
        cropDesc={translate('form.design1_crop_desc', 'Kırpma alanı 1. tasarım oranında kilitli.')}
        {...props}
      />

      <h3 style={{ marginTop: 28 }}>
        {translate('form.visual_design2', 'Dikey Görsel (1080×1350)')}
      </h3>
      <span
        style={{
          backgroundColor: '#0ABAB5',
          color: 'white',
          borderRadius: 10,
          fontSize: 12.5,
          padding: 5,
          marginTop: -10,
          marginBottom: 8,
          display: 'inline-block',
        }}
      >
        {translate(
          'form.visual_design2_hint',
          'Dikey görsel 4:5 (1080×1350). Ana sayfa 2. tasarım listesi ve poster.',
        )}
      </span>
      <EditableImage
        record={record}
        source="banner"
        aspect={DESIGN2_ASPECT}
        width={DESIGN2_WIDTH}
        height={DESIGN2_HEIGHT}
        hint={translate(
          'form.design2_crop_hint',
          '2. tasarım 4:5 (1080×1350). Kaydetmeden önce kırpın.',
        )}
        cropTitle={translate('form.design2_crop_title', {
          _: 'Görseli Kırp (4:5)',
        })}
        cropDesc={translate(
          'form.design2_crop_desc',
          'Kırpma alanı 2. tasarım (4:5) oranında kilitli.',
        )}
        {...props}
      />

      <h3>{translate('form.event_video', 'Event Video')}</h3>
      <span
        style={{
          backgroundColor: '#0ABAB5',
          color: 'white',
          borderRadius: 10,
          fontSize: 12.5,
          padding: 5,
          marginTop: -10,
          marginBottom: 8,
          display: 'inline-block',
        }}
      >
        {translate(
          'form.video_hint',
          'Please note that the entry should only contain the ID (the code after ?v=) of the video NOT the whole URL.',
        )}
      </span>
      <TextInput
        source="videoURL"
        label={translate('form.video_label', 'Video ID (Youtube ID)')}
        fullWidth
        defaultValue={null}
      />

      <h3>{translate('form.venue_layout', 'Venue Layout')}</h3>
      <span style={{ fontSize: 14, marginTop: -10, marginBottom: 20, display: 'block' }}>
        {translate(
          'form.layout_desc',
          'If there is a specific layout for this event. If not default layout for the venue will be used.',
        )}
      </span>
      <span
        style={{
          backgroundColor: '#0ABAB5',
          color: 'white',
          borderRadius: 10,
          fontSize: 12.5,
          padding: 5,
          marginTop: -10,
          marginBottom: 8,
          display: 'inline-block',
        }}
      >
        {translate(
          'form.layout_hint',
          'Square ratio images should be uploaded. Both sides should be equal.',
        )}
      </span>
      <ImageInput source="venueLayout" label=" " accept="image/*" defaultValue={null}>
        <ImageField source="src" />
      </ImageInput>
    </React.Fragment>
  );
};
